module.exports = __webpack_public_path__ + "img/charts-pie-and-bars.fa1a2846.svg";